/// <reference path="../pocmemberform.js" />
import React, { useEffect, useState } from 'react';
import { Col, FormCheck, FormControl, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import '../../../../styles/Forms.css';

export function NameSection(props) {
    const [firstName, setFirstName] = useState(props.member.firstName);
    const [middleName, setMiddleName] = useState(props.member.middleName?props.member.middleName:"");
    const [noMiddleName,setNoMiddleName] = useState(props.member.hasNoMiddleName)
    const [lastName, setLastName] = useState(props.member.lastName);

    useEffect(() => {
        props.member.firstName = firstName;
        props.member.middleName = middleName;
        props.member.lastName = lastName;
        props.member.hasNoMiddleName = noMiddleName;
        props.checkOkay();
    }, [firstName, middleName, lastName, noMiddleName])

    return (
        <><OverlayTrigger
            placement="bottom"
            delay={{ show: 250, hide: 400 }}
            overlay={<Tooltip id="legal-name-tip">
                Please do not include any special characters (', -, etc.) 
            </Tooltip>}
        >
            <Row>
                <Col className="d-flex justify-content-start" style={{ padding: "4px" }}>
                    <div style={{ paddingRight: "5px" }}>First Name</div>
                    <FormControl
                        required
                        isInvalid={firstName === null || firstName === ""}
                        type="text"
                        placeholder="First Name"
                        defaultValue={(firstName) ? firstName : undefined}
                        id="first-name"
                        name="first-name"
                        aria-label="first-name"
                        aria-describedby="first-name"
                        onChange={(e) => { setFirstName(e.target.value) }}
                    />
                </Col>
                <Col className="d-flex justify-content-center" style={{ padding: "4px" }}>
                    <div style={{ paddingRight: "5px" }}>Middle</div>
                    <FormControl
                        required
                        isInvalid={(!middleName || middleName === "") && !noMiddleName}
                        disabled={noMiddleName}
                        type="text"
                        placeholder="Middle"
                        value={middleName}
                        id="middle-name"
                        name="middle-name"
                        aria-label="middle-name"
                        aria-describedby="middle-name"
                        onChange={(e) => { setMiddleName(e.target.value) }}
                    />
                </Col>
                <Col className="d-flex justify-content-end" style={{ padding: "4px" }}>
                    <div style={{ paddingRight: "5px" }}>Last Name</div>
                    <FormControl
                        required
                        isInvalid={lastName === null || lastName === ""}
                        type="text"
                        placeholder="Last Name"
                        defaultValue={(lastName) ? lastName : undefined}
                        id="last-name"
                        name="last-name"
                        aria-label="last-name"
                        aria-describedby="last-name"
                        onChange={(e) => { setLastName(e.target.value) }}
                    />
                </Col>
            </Row>
        </OverlayTrigger>
            <Row>
                <Col className="d-flex justify-content-center" style={{ padding: "4px" }}>
                    <FormCheck
                        inline
                        label="No middle name?"
                        checked={noMiddleName}
                        name="access"
                        type="checkbox"
                        id="no-middle-name-check"
                        onChange={(e) => { setMiddleName(""); setNoMiddleName(e.target.checked); }}
                    />
                </Col>
            </Row>
        </>
    );
}